import * as formik from 'formik';
import * as yup from 'yup';

import { Form, Modal } from "react-bootstrap";
import { displayName, formatInReal, isNullOrEmpty } from '../../commons/util/HallAppUtil';
import { useEffect, useState } from 'react';

import AppButton from '../../commons/buttons/AppButton';
import AppCurrencyInput from '../../commons/inputs/AppCurrencyInput';
import AppInput from '../../commons/inputs/AppInput';
import AppLinkButton from '../../commons/buttons/AppLinkButton';
import AppLoading from '../../commons/AppLoading';
import AppTextAreaInput from '../../commons/inputs/AppTextAreaInput';
import Button from 'react-bootstrap/Button';
import CompanyAPI from '../company/CompanyAPI';
import HallAppToast from '../../commons/HallAppToast';
import SelectBasicInput from '../../commons/inputs/SelectBasicInput';
import StockAPI from './StockAPI';
import UserService from '../../auth/UserService';

const registerTypes = [
    { key: 'INPUT', label: 'Registrar Entrada' },
    { key: 'OUTPUT', label: 'Registrar Saida' }
]

const optionsDetinations = [
    { key: 'CONSUMPTION', label: 'Consumo' },
    { key: 'SALE', label: 'Venda' },

]

const stockAPI = new StockAPI()
const companyAPI = new CompanyAPI()
const userAPI = new UserService()

function RegisterStockModal({ closeShow, show, productToEdit, callGetProducts }) {

    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingPage, setIsLoadingPage] = useState(true)
    const [employees, setEmployees] = useState([])
    const [currentResponsible, setCurrentResponsible] = useState({})
    const [selectedEmployee, setSelectedEmployee] = useState([])

    useEffect(() => {
        getAllEmployee();
    }, []);


    const getAllEmployee = async () => {
        try {
            const response = await companyAPI.getAllEmployee(companyAPI.getCompanyManagment().id);
            const options = [
                { key: '', label: 'Selecione...' }, // 👈 primeira opção vazia
                ...response.data.map(d => ({
                    key: d.id,
                    label: displayName(d.name) || d.email,
                })),
            ];
            setCurrentResponsible(response.data.find((e) => e.id === userAPI.getUserData().id));
            setEmployees(options)
        } catch (_) {
            setEmployees([])
        }
    };

    const [initialValues, setInitialValues] = useState({
        registerType: '',
        quantity: '',
        destinationType: '',
        description: '',
        employeeId: '',
        value: productToEdit?.purchaseCost
    });

    const { Formik } = formik;

    const schema = yup.object().shape({
        registerType: yup.string(),
        quantity: yup.string().required('Informe uma quantidade'),
        destinationType: yup.string(),
        description: yup.string(),
    });

    const save = async (values) => {

        if (values.registerType === 'OUTPUT' && selectedEmployee.length === 0) {
            HallAppToast.error('Selecione pelo menos 1 respónsavel.')
            throw new Error("Selecione pelo menos 1 respónsavel")
        }

        const data = {
            ...values,
            registerType: values.registerType || 'INPUT',
            destinationType: values.registerType === 'INPUT' || !values.registerType ? null : (values.destinationType || 'CONSUMPTION'),
            productId: productToEdit.id,
            employeeIds: selectedEmployee.length === 0 ? [currentResponsible?.id] : selectedEmployee
        }

        setIsLoading(true)
        try {
            await stockAPI.movementStock(data);
            HallAppToast.success();
            if (callGetProducts) callGetProducts()
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false)
        }
    }

    function addEmployee(employeeId) {
        setSelectedEmployee((prev) => {
            // se já existir, não faz nada
            if (prev.includes(employeeId)) {
                return prev;
            }
            // se não existir, adiciona no array
            return [...prev, employeeId];
        });
    }

    function removeEmployee(employeeId) {
        setSelectedEmployee((prev) => {
            // remove todos que forem iguais ao employeeId
            return prev.filter((id) => id != employeeId);
        });
    }



    return (
        <>
            <Modal show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header className='custom-close-button' closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        REGISTRAR ENTRADA OU SAIDA
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Formik
                        validationSchema={schema}
                        onSubmit={save}
                        initialValues={initialValues}
                        enableReinitialize={true}
                    >
                        {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <div className='container'>
                                    <SelectBasicInput
                                        isRequired
                                        errors={errors}
                                        touched={touched}
                                        name='registerType'
                                        onChange={(e) => {
                                            handleChange(e)
                                            console.log(e.target.value)
                                            if (e.target.value == 'INPUT') {
                                                setFieldValue("value", productToEdit?.purchaseCost)
                                            } else {
                                                setFieldValue("value", productToEdit?.salesValue)
                                            }
                                        }}
                                        value={values.registerType}
                                        options={registerTypes}
                                        label='Tipo de Registro'
                                    />
                                    <AppInput
                                        errors={errors}
                                        isRequired
                                        touched={touched}
                                        name="quantity"
                                        onChange={handleChange}
                                        value={values.quantity}
                                        type="text"
                                        label="Quantidade"
                                    />

                                    <AppCurrencyInput
                                        errors={errors}
                                        touched={touched}
                                        name="value"
                                        value={values.value}
                                        type="text"
                                        label={values.registerType !== 'OUTPUT' ? 'Custo de Compra (unitario)' : 'Valor de Venda  (unitario)'}
                                        onChange={(_, value) => {
                                            setFieldValue("value", value)
                                        }} />

                                    {
                                        values.registerType === 'OUTPUT' && <SelectBasicInput
                                            isRequired
                                            errors={errors}
                                            touched={touched}
                                            name='destinationType'
                                            onChange={handleChange}
                                            value={values.destinationType}
                                            options={optionsDetinations}
                                            label='Unidade de Medida'
                                        />
                                    }

                                    {
                                        values.registerType === 'OUTPUT' && <SelectBasicInput
                                            isRequired
                                            errors={errors}
                                            touched={touched}
                                            name='employeeId'
                                            options={employees}
                                            value={values.employeeId}
                                            onChange={(e) => {
                                                handleChange(e);
                                                addEmployee(e.target.value);
                                                setFieldValue('employeeId', '');
                                            }}
                                            label='Responsável'
                                        />
                                    }
                                    <div className="mt-2">
                                        <strong>Selecionados:</strong>
                                        <ul className="mt-2">
                                            {selectedEmployee
                                                .map(id => employees.find(emp => emp.key == id))
                                                .filter(Boolean)
                                                .map(e => (
                                                    <li key={e.key}>{e.label}  <Button
                                                        variant="link"
                                                        style={{ textDecoration: 'none' }}
                                                        onClick={() => removeEmployee(e.key)}>
                                                        remover
                                                    </Button>
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>



                                    <AppTextAreaInput
                                        errors={errors}
                                        touched={touched}
                                        name='description'
                                        onChange={handleChange}
                                        value={values.description}
                                        type="text"
                                        label='Observação'
                                    />

                                    {values.registerType === 'OUTPUT' && values.destinationType == 'SALE' &&
                                        <div>
                                            <hr></hr>
                                            <div className="d-flex justify-content-between">
                                                <span>Valor total:</span>
                                                <span>{formatInReal((values.value * values.quantity) || 0)}</span>
                                            </div>
                                            <hr></hr>
                                        </div>
                                    }

                                    {isLoading ? <div style={{ textAlign: 'center' }}>
                                        <AppLoading />
                                    </div> :
                                        <AppButton type="submit" width='100%' name='salvar' />
                                    }

                                  
                                </div>


                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default RegisterStockModal;